import { c as _c } from "react/compiler-runtime";
import { QuantitySelector } from '@sprd/sprd-component-kit/v2';
import { useIsMutating } from '@tanstack/react-query';
import { useState } from 'react';
import { useLocale, useTranslations } from 'next-intl';
import { LineItem, LineItemGroup } from '@/types/commercetools';
import { useRemoveItem, useUpdateQuantity } from '@/hooks/useCartHooks';
import { useDebounce } from '@/hooks/useDebounce';
import useProductType from '@/hooks/useProductType';
import { getSizeId, getSizeName } from '@/utility/lineItems/lineItemHelpers';
export const BasketSize = t0 => {
  const $ = _c(39);
  const {
    lineItem,
    lineItemGroup
  } = t0;
  const t = useTranslations();
  const [quantity, setQuantity] = useState(lineItem.quantity);
  const updateQuantity = useUpdateQuantity(lineItemGroup);
  const removeItem = useRemoveItem(lineItemGroup);
  const locale = useLocale();
  const {
    data: productType
  } = useProductType(lineItemGroup.shopId, lineItemGroup.productTypeId, locale);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      mutationKey: ["cart-action"]
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isMutating = useIsMutating(t1) > 0;
  let t2;
  if ($[1] !== lineItem || $[2] !== removeItem || $[3] !== updateQuantity) {
    t2 = (action, payload) => {
      if (action === "update" && payload) {
        updateQuantity.mutate({
          lineItem,
          payload
        }, {
          onError: () => setQuantity(lineItem.quantity)
        });
      } else {
        if (action === "delete") {
          removeItem.mutate({
            lineItem
          });
        }
      }
    };
    $[1] = lineItem;
    $[2] = removeItem;
    $[3] = updateQuantity;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const debouncedAction = useDebounce(t2, 300);
  let t3;
  if ($[5] !== debouncedAction || $[6] !== quantity) {
    t3 = newQuantity => {
      const previousQuantity = quantity;
      setQuantity(newQuantity);
      debouncedAction("update", {
        quantity: newQuantity,
        previousQuantity
      });
    };
    $[5] = debouncedAction;
    $[6] = quantity;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleUpdateQuantity = t3;
  let t4;
  if ($[8] !== debouncedAction) {
    t4 = () => debouncedAction("delete");
    $[8] = debouncedAction;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleDelete = t4;
  let t5;
  if ($[10] !== lineItem || $[11] !== productType?.sizes) {
    t5 = getSizeName(productType?.sizes ?? [], getSizeId(lineItem));
    $[10] = lineItem;
    $[11] = productType?.sizes;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const sizeName = t5;
  const t6 = lineItem.id;
  let t7;
  if ($[13] !== sizeName) {
    t7 = <span>{sizeName}</span>;
    $[13] = sizeName;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = lineItem.id;
  let t9;
  if ($[15] !== t) {
    t9 = t("size.guide.size");
    $[15] = t;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t) {
    t10 = t("miniBasket.deleteSize");
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t) {
    t11 = t("miniBasket.addSize");
    $[19] = t;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t) {
    t12 = t("miniBasket.deleteSize");
    $[21] = t;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t10 || $[24] !== t11 || $[25] !== t12 || $[26] !== t9) {
    t13 = {
      input: t9,
      deleteButton: t10,
      increaseButton: t11,
      decreaseButton: t12
    };
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
    $[26] = t9;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== handleDelete || $[29] !== handleUpdateQuantity || $[30] !== isMutating || $[31] !== lineItem.id || $[32] !== quantity || $[33] !== t13) {
    t14 = <QuantitySelector id={t8} disabled={isMutating} quantity={quantity} onChange={handleUpdateQuantity} onDelete={handleDelete} max={10000} labels={t13} />;
    $[28] = handleDelete;
    $[29] = handleUpdateQuantity;
    $[30] = isMutating;
    $[31] = lineItem.id;
    $[32] = quantity;
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== lineItem.id || $[36] !== t14 || $[37] !== t7) {
    t15 = <div key={t6} className="flex items-center justify-between">{t7}{t14}</div>;
    $[35] = lineItem.id;
    $[36] = t14;
    $[37] = t7;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  return t15;
};